<template>
  <a-spin :spinning="spinning">
    <a-card>
      <div class="search">
        <a-form layout="horizontal" :model="form">
          <a-row>
            <a-col :md="6" :sm="24">
              <a-form-item
                label="开始日期"
                :labelCol="{ span: 6 }"
                :wrapperCol="{ span: 15 }"
              >
                <a-date-picker
                  v-model="form.start"
                  format="YYYY-MM-DD"
                  placeholder="请选择日期"
                  @change="changeDateStart"
                  :locale="locale"
                />
                <!-- <a-input></a-input> -->
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item
                label="结束日期"
                :labelCol="{ span: 6 }"
                :wrapperCol="{ span: 15 }"
              >
                <a-date-picker
                  v-model="form.end"
                  format="YYYY-MM-DD"
                  placeholder="请选择日期"
                  @change="changeDateEnd"
                  :locale="locale"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item
                label="报销人"
                :labelCol="{ span: 6 }"
                :wrapperCol="{ span: 15 }"
              >
                <a-input
                  placeholder="请输入"
                  v-model.trim="form.applyUser"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-button type="primary" @click="search()">查询</a-button>
              <div class="space"></div>
              <a-button type="default" @click="reset()">重置</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div style="text-align: left; margin-bottom: 10px">
        <a-button type="primary" v-print="printObj"
          ><span class="iconfont icon-print"></span
          ><span style="margin-left: 5px">打印</span></a-button
        >
        <a-button
          style="margin-left: 10px"
          type="default"
          @click="export2Excel"
        >
          导出excel</a-button
        >
      </div>
      <div class="table" id="print">
        <standard-table
          :columns="columns"
          :dataSource="listData"
          :loading="loading"
          :pagination="false"
          bordered
        >
          <template slot="title">
            <h2 style="margin-bottom: 0px; text-align: center">
              费用报销汇总表
            </h2>
            <div
              style="font-size: 16px; text-align: right; padding-right: 120px"
            >
              <span
                style="display: inline-block; width: 50px; text-align: center"
                >{{ year }}</span
              >
              年<span
                style="display: inline-block; width: 50px; text-align: center"
                >{{ month }}</span
              >月<span
                style="display: inline-block; width: 50px; text-align: center"
                >{{ day }}</span
              >日
            </div>
            <table
              border="1"
              style="
                border-collapse: collapse;
                border: 1px solid #e8e8e8;
                margin-left: -1px;
              "
              height="50px"
              width="101%"
            >
              <tr style="background-color: #fafafa; text-align: center">
                <td
                  style="
                    border-right: 1px solid #e8e8e8;
                    width: 12%;
                    text-align: left;
                    padding: 0px 25px;
                  "
                >
                  报销部门
                </td>
                <td
                  style="
                    border-right: 1px solid #e8e8e8;
                    border-left: 1px solid #fafafa;
                    width: 20%;
                  "
                ></td>
                <td
                  style="
                    border-right: 1px solid #e8e8e8;
                    border-left: 1px solid #fafafa;
                    width: 10%;
                  "
                >
                  日期区间
                </td>
                <td
                  style="
                    border-right: 1px solid #e8e8e8;
                    border-left: 1px solid #fafafa;
                    width: 30%;
                  "
                >
                  <span v-show="form.start && this.form.end">{{
                    `${this.form.start} ~ ${this.form.end}`
                  }}</span>
                </td>
                <td
                  style="
                    border-right: 1px solid #e8e8e8;
                    border-left: 1px solid #fafafa;
                    width: 10%;
                  "
                >
                  报销人
                </td>
                <td style="border-right: 1px solid #fafafa; width: 20%">
                  {{ applyUserTemp }}
                </td>
              </tr>
            </table>
          </template>
        </standard-table>
        <table
          class="footer"
          style="
            border-collapse: collapse;
            border: 1px solid #e8e8e8;
            border-top: 1px solid #fafafa;
            margin-bottom: 0px;
          "
          height="100px"
          width="100%"
          border="1"
        >
          <tr>
            <td style="width: 12%; text-align: left; padding-left: 10px">
              报销金额合计
            </td>
            <td style="width: 8%; text-align: center">（大写）</td>
            <td style="width: 40%; text-align: center">
              {{ $convertCurrency(smallMoney) }}
            </td>
            <td style="width: 10%; text-align: center">（小写）</td>
            <td style="width: 20%; text-align: center">
              {{
                smallMoney == 0
                  ? ""
                  : returnFloat(Number(smallMoney).toLocaleString(), "price")
              }}
            </td>
            <td style="width: 10%; text-align: center">银联</td>
          </tr>
          <tr>
            <td style="text-align: left; padding-left: 10px">部门会计签批</td>
            <td colspan="2"></td>
            <td style="text-align: left; padding-left: 10px">部门经理审核</td>
            <td colspan="2" style="text-align: left; padding-left: 10px"></td>
          </tr>
        </table>
      </div>
    </a-card>
  </a-spin>
</template>

<script>
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import StandardTable from "@/components/StandardTable";
import { cost_apply_list } from "@/api/modules/summaryManagement.js";
import moment from "moment";
export default {
  name: "expenseReimbursementManagement",
  data() {
    return {
      locale,
      spinning: false,
      loading: false,
      advanced: false,
      listData: [],
      listDataExcel: null,
      smallMoney: 0,
      applyUserTemp: "",
      year: "",
      month: "",
      day: "",
      form: {
        applyUser: "",
        start: "",
        end: "",
      },
      columns: [
        {
          title: "序号",
          dataIndex: "index",
          key: "index",
          align: "center",
          width: 80,
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          title: "类型",
          dataIndex: "type",
          align: "center",
        },
        {
          title: "报销事由",
          dataIndex: "applyDesc",
          align: "center",
        },
        {
          title: "报销金额",
          dataIndex: "applyMoney",
          align: "center",
        },
        {
          title: "报销人",
          dataIndex: "applyUser",
          align: "center",
        },
      ],
      printObj: {
        id: "print",
        popTitle: "",
        extraCss: "",
      },
    };
  },
  components: {
    StandardTable,
  },
  created(){
    this.init()
    this.search()
  },
  methods: {
    init() {
      let dataArr = this.$moment(new Date()).format("YYYY-MM-DD").split("-");
      this.form.start = `${dataArr[0]}-${dataArr[1]}-01`;
      this.form.end = this.$moment(new Date()).format("YYYY-MM-DD");
    },
    search() {
      this.smallMoney = 0;
      if (this.form.start === "") {
        return this.$message.warn("请选择开始日期");
      }
      if (this.form.end === "") {
        return this.$message.warn("请选择结束日期");
      }
      if (
        new Date(this.form.start).getTime() > new Date(this.form.end).getTime()
      ) {
        this.form.start = "";
        this.form.end = "";
        return this.$message.warn("开始日期不能大于结束日期");
      }
      let params = {
        applyUser: this.form.applyUser,
        start: this.form.start,
        end: this.form.end,
      };
      this.loading = true;
      cost_apply_list("", params).then((res) => {
        this.loading = false;
        if (res.code == "0000") {
          this.applyUserTemp = this.form.applyUser;
          let curDate = this.$moment(new Date()).format("YYYY-MM-DD");
          let date = curDate.split("-");
          this.year = date[0];
          this.month = date[1];
          this.day = date[2];
          this.listData = res.data.map((item) => {
            for (let key in item) {
              if (item[key] == "" || item[key] == null) {
                item[key] = "--";
              }
              if (key == "applyMoney") {
                this.smallMoney += Number(item[key]);
                item[key] = this.returnFloat(
                  Number(item[key]).toLocaleString(),
                  "price"
                );
              }
            }
            return item;
          });
          this.listData = this.listData.filter(
            (item) => item.applyMoney !== "0.000"
          );
        } else {
          this.$message.warn(res.msg);
        }
        this.loading = false;
      });
    },
    changeDateStart(val) {
      if (val == null || val == undefined || val == "") {
        return (this.form.start = "");
      }
      this.form.start = moment(val).format("YYYY-MM-DD");
    },
    changeDateEnd(val) {
      if (val == null || val == undefined || val == "") {
        return (this.form.end = "");
      }
      this.form.end = moment(val).format("YYYY-MM-DD");
    },
    reset() {
      this.init()
    },
    //金额或数量小数点不足两位自动补零
    returnFloat(value, flag) {
      var s = value.toString().split(".");
      if (s.length == 1 && flag == "price") {
        value = value.toString() + ".000";
        return value;
      } else if (s.length == 1 && flag == "weight") {
        value = value.toString() + ".00";
        return value;
      }
      if (s.length > 1 && flag == "price") {
        if (s[1].length == 1) {
          value = value.toString() + "00";
        }
        if (s[1].length == 2 && flag == "price") {
          value = value.toString() + "0";
        }
        return value;
      } else if (s.length > 0 && flag == "weight") {
        if (s[1].length == 1) {
          value = value.toString() + "0";
        }
        return value;
      }
    },
    async export2Excel() {
      let params = {
        applyUser: this.form.applyUser,
        start: this.form.start,
        end: this.form.end,
      };
      await cost_apply_list("", params).then((res) => {
        if (res.code == "0000") {
          this.applyUserTemp = this.form.applyUser;
          let curDate = this.$moment(new Date()).format("YYYY-MM-DD");
          let date = curDate.split("-");
          this.year = date[0];
          this.month = date[1];
          this.day = date[2];
          this.listDataExcel = res.data.map((item) => {
            for (let key in item) {
              if (item[key] == "" || item[key] == null) {
                item[key] = "--";
              }
              if (key == "applyMoney") {
                this.smallMoney += Number(item[key]);
                item[key] = this.returnFloat(
                  Number(item[key]).toLocaleString(),
                  "price"
                );
              }
            }
            return item;
          });
        } else {
          this.$message.warn(res.msg);
        }
      });
      require.ensure([], () => {
        const { export_json_to_excel } = require("../../excel/Export2Excel");
        const tHeader = ["报销人", "采购日期", "报销事由", "报销金额"];
        const filterVal = [
          "applyUser",
          "purchaseDate",
          "applyDesc",
          "applyMoney",
        ];
        const data = this.formatJson(filterVal, this.listDataExcel);
        export_json_to_excel(tHeader, data, "报销汇总表");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
  },
};
</script>

<style lang="less" scoped>
.space {
  display: inline-block;
  margin: 0 5px;
}
/deep/.ant-form-item-label {
  width: 100px !important;
}
.ant-calendar-picker {
  width: 100%;
}
/deep/.ant-table-title {
  padding-top: 16px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
  padding-bottom: 0px !important;
}
/deep/ .ant-table-footer {
  padding: 0 !important;
  margin-top: -5px;
}
</style>
